import React, { useState, useEffect } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "bootstrap/dist/css/bootstrap.min.css";
import "./table.css";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function TableDimensions(props) {
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-3">
      Mostrando de la {from} a la {to} de {size}
    </span>
  );

  const [productsState, setProductsState] = useState([]);
  const [columns, setColumns] = useState([]);
  const [windowWidth, setWindowWidth] = useState(getWindowDimensions().width);

  useEffect(() => {
    setProductsState(props.data);
    if (props.data.length > 0) {
      setColumns(
        Object.keys(props.data[0]).map(function (x) {
          return {
            dataField: x,
            text: props.columnLabels && props.columnLabels[x] ? props.columnLabels[x] : x,
            sort: true,
            headerStyle: { 
              minWidth: '10rem', 
              maxWidth: '17rem', 
              whiteSpace: "nowrap", 
              overflow: "hidden", 
              textOverflow: "ellipsis" 
            },
            style: { 
              minWidth: '10rem', 
              maxWidth: '17rem', 
              whiteSpace: "nowrap", 
              overflow: "hidden", 
              textOverflow: "ellipsis" 
            }
          };
        })
      );
    }
  }, [props.data, props.columnLabels]);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(getWindowDimensions().width);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowWidth]);

  let size = 4;
  if (props.size !== undefined) {
    size = props.size;
  }

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: size,
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "4",
        value: 4,
      },
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "All",
        value: productsState.length,
      },
    ],
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    alwaysShowAllBtns: true,
  });

  return (
    <div>
      {productsState && productsState.length === 0 ? (
        <div className="no-result">
          No hay resultados para los criterios de búsqueda seleccionados
        </div>
      ) : (
        <BootstrapTable
          responsive
          classes="table-basic table-hover table-borderless"
          bootstrap4
          keyField="COD_PROVINCIA"
          data={productsState}
          pagination={pagination}
          columns={columns}
        />
      )}
    </div>
  );
}

export default TableDimensions;
